import { render, staticRenderFns } from "./ProductDisplay.vue?vue&type=template&id=2854e540&scoped=true&lang=pug&"
import script from "./ProductDisplay.vue?vue&type=script&lang=js&"
export * from "./ProductDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ProductDisplay.vue?vue&type=style&index=0&id=2854e540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2854e540",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/boyoon/Desktop/Project/kl3/wonderapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2854e540')) {
      api.createRecord('2854e540', component.options)
    } else {
      api.reload('2854e540', component.options)
    }
    module.hot.accept("./ProductDisplay.vue?vue&type=template&id=2854e540&scoped=true&lang=pug&", function () {
      api.rerender('2854e540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "scripts/vue-components/product/ProductDisplay.vue"
export default component.exports